export const dateFormat = [
    { key: 1, value: 'DD-MM-YYYY' },
    { key: 2, value: 'MM-DD-YYYY' },
    { key: 3, value: 'YYYY-DD-MM' },
];

export const timeFormat = [
    { key: 1, value: 'HH:mm:ss' },
    { key: 2, value: 'HH:mm' },
];

export const decimalNumberSystem = [
    { key: 1, value: '10,000,000.00' },
    { key: 2, value: '1,00,00,000.00' },
    { key: 3, value: '10’000’000.00' },
    { key: 4, value: '10 000 000.00' },
];

export const numberSystem = [
    { key: 1, value: '10,000,000' },
    { key: 2, value: '1,00,00,000' },
    { key: 3, value: '10’000’000' },
    { key: 4, value: '10 000 000' },
];
